import React from "react";
import { Button } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Footer from './footer';
import { motion } from "framer-motion";
import LatestUpdates from "./latestupdates";
import "./footer.css";
import "./img.css";
import "./carousel.scss";
import "./clearfix.scss";
import "./animate-min.css";
import "./animate.css";

const ContactPage = () => {
    const offices = [
        {
            title: "Melbourne (CBD)",
            phone1: "03 9077 0507",
            phone2: "0406 401 000",
            email: "enquiries@bajwaimmigration.com",
            address: "Century Building, Level 5/125 Swanston Street, Melbourne VIC 3000",
            img: "./img/Melbourne1.png",
        },
        {
            title: "Thomastown (Northern Suburbs)",
            phone1: "0410 516 709",
            email: " thomastown@bajwaimmigration.com",
            address: " 177 High St. Thomastown VIC 3074",
            img: "./img/Thomastown1.png",
           
        },
       
        {
            title: "Dandenong (Eastern Suburbs)",
            phone1: "0451 355 710",
            email: "amar@bajwaimmigration.com",
            address: "Unit 7/147-151 Foster Street, Dandenong, VIC, 3175",
            img: "./img/Dandenong1.png",
        },
        {
            title: "Tarneit (Western Suburbs)",
            phone1: "0434 669 744",
            phone2: "0411 562 901",
            email: "tarneit@bajwaimmigration.com",
            address: "435 Sayers Rd.Hoppers Crossing VIC 3029",
            img: "./img/Tarneit1.png",

        },
        {
            title: "Sydney",
            phone1: " 0410 823 030",
            phone2: "",
            email: "info.sydney@bajwaimmigration.com    ",
            address: "Suite 1, Level 6, 9 George Street, Parramatta NSW 2150",
            img: "./img/Sydney1.png",

        },
        {
            title: "Brisbane",
            phone1: "  0424 985 908",
            phone2: "0738 017 070",
            email: "qld@bajwaimmigration.com ",
            address: " 26 Balaclava Street Woolloongabba, Brisbane, QLD 4102",
            img: "./img/Brisbane1.png",

        },
        {
            title: " Adelaide",
            phone1: "  0416 823 541",
            email: " adelaide@bajwaimmigration.com  ",
            address: " Ground floor, 30 Currie street Adelaide, SA",
            img: "./img/Adelaide1.png"

        },
        {
            title: "Perth",
            phone1: "0489 247 000",
            phone2: "0410 521 731",
            email: "  WA@bajwaimmigration.com  ",
            address: "Suite 23, level 6, 231 Adelaide Terrace, PERTH 6000 WA",
            img: "./img/Perth1.png",

        },

        // {
        //     title: " Hobart",
        //     phone1: " 0416 813 370",
        //     email: "  tasmania@bajwaimmigration.com ",
        //     // address: " ",
        //     img: "./img/Hobart1.png",
        // },
        {
            title: "  Jalandhar",
            phone1: " +91 97168 93000",
            phone2: " +91 97168 94000",
            email: "   jalandhar@bajwaimmigration.com   ",
            address: " SCO 8 & 9 First Floor, Crystal Plaza, Garha Road Chhoti Baradari Jalandhar Punjab 144001 (IND) ",
            img: "./img/Jalandhar1.png",
        },
        {
            title: " Amritsar",
            phone1: " +91 97097 03062",
            phone2: "+91 97097 03082",
            email: "   amritsar@bajwaimmigration.com",
            address: "26-SU, 1st floor, B-Block Market, New Amritsar, Amritsar Punjab 143001 (IND) ",
            img: "./img/Amritsar1.png",
        },
        {
            title: "  New Delhi",
            phone1: "  +91 99995 18787",
            email: "  delhi@bajwaimmigration.com ",
            address: "28/5 Double Story, Ashok Nagar, Tilak Nagar Jail Road, 3rd Floor, New Delhi 110018 ",
            img: "./img/New Delhi1.png",
        },
        {
            title: "  Geelong",
            phone1: "  0415 474 412",
            phone2: "0415 338 664",
            email: "  Geelong@bajwaimmigration.com ",
            address: "Level 2/83 Moorabool Street, Geelong-3220 ",
            img: "./img/Geelong1.jpg",
        },
        {
            title: "   Calgary ",
            phone1: "  4034 474 000",
            email: "  Canada@bajwaimmigration.com ",
            address: "4715 88 Ave NE #2000, Calgary, AB T3J 4C5 (Dhillon Business Plaza) ",
            img: "./img/Calgary1.jpg",
        },


        
    ];

    return (
        <>
            <div className="container-fluid contact overflow-hidden pb-5">
                <div className="container py-5">
                    <div className="office pt-5">
                        <div className="section-title text-center mb-5">
                            <div className="sub-style">
                                <h5 className="sub-title text-primary px-3">Worldwide Offices</h5>
                            </div>
                            <h1 className="display-5 mb-4">Explore Our Office Worldwide</h1>
                            <p>
                                We provide expert immigration and visa services for various countries, ensuring a seamless transition for individuals and families.
                            </p>
                        </div>
                        <div className="row g-4 justify-content-center">
                            {offices.map((office, index) => (
                                <div key={index} className="col-md-6 col-lg-4 col-xl-3">
                                    <div className="office-item p-4 h-100 d-flex flex-column border rounded shadow-sm">
                                        {office.img && (
                                            <div className="office-img mb-3 text-center">
                                                <img src={office.img} className="img-fluid w-100 rounded" alt={office.title} />
                                            </div>
                                        )}
                                        <h4>{office.title}</h4>
                                        <a href={`tel:${office.phone1}`} className="text-secondary fs-5 mb-2">
                                            {office.phone1} {office.phone2 && <br />} {office.phone2}
                                        </a>
                                        <a href={`mailto:${office.email}`} className="text-muted fs-5 mb-2 text-break">
                                            {office.email}
                                        </a>
                                        {office.address && (
                                            <p>
                                                <a
                                                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(office.address)}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-decoration-none text-dark"
                                                >
                                                    {office.address}
                                                </a>
                                            </p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 pt-5">
                <iframe
                    className="rounded w-100"
                    style={{ height: "500px" }}
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.9468415413508!2d144.9658574!3d-37.8147141!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642b5c284405b%3A0x7294ed92bcdfc789!2sSuite%20505%20Level%205%2F125%20Swanston%20St%2C%20Melbourne%20VIC%203000%2C%20Australia!5e0!3m2!1sen!2sin!4v1743479675317!5m2!1sen!2sin"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
            </div>

            <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 stAAT-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>

            <LatestUpdates />
            <Footer />
        </>
    );
};

export default ContactPage;
